<ng-container *transloco="let t">
  <pxw-alert type="warning" size="sm" display="inline-block">
    {{ message() }}

    <ng-template #alertDetails>
      <pxw-input-checkbox
        name="outOfDeliveryZoneConfirmation"
        [legend]="t('shippingCostResponse.outOfDeliveryZoneConfirmLabel')"
        [(ngModel)]="outOfDeliveryZoneConfirmed"
      />
    </ng-template>
  </pxw-alert>
  <pxw-form-validation
    name="outOfDeliveryZoneConfirmationValidation"
    style="margin-top: 0.3em"
    [displayErrors]="isFormSubmitted()"
    [ngModel]="outOfDeliveryZoneConfirmed()"
    [requiredTrue]="true"
  />
</ng-container>
